import { createToastMessage, ToastMessage } from '@msaf/core-react'
import { useRequestCsvExport } from '../hooks/use-api'
import useToastMessage from '../hooks/use-toast-message'
import { ERROR_MESSAGES } from '../components/errors/messages'
import { CSV_EXPORT_FILE_NAME_DATE_OPTIONS } from './constants'

type ExportCsvResponse = {
  url: string
  fileName: string
}

export function ExportSearchResultsToCsv(actionUrl: string, csrfToken?: string, actionQuery?: string) {
  const body = new FormData()
  body.append('csrfmiddlewaretoken', csrfToken ?? '')
  body.append('query', actionQuery ?? '')

  const {
    mutate: requestCsvExportUrl,
    isError,
    error,
    isLoading,
  } = useRequestCsvExport({ url: actionUrl, body, onSuccess: onSuccessDownloadCsv, onError: onErrorDownloadCsv })

  useToastMessage({
    error,
    // Trigger the toast success message once the export has been requested. Success is indicated to user by file download.
    isSuccess: isLoading,
    isError,
    successMessage: 'CSV Export has been requested, your download will commence shortly. Please do not navigate away',
  })

  function onErrorDownloadCsv() {
    createToastMessage(<ToastMessage messageType='error' title='Error' message={ERROR_MESSAGES.CSV_DOWNLOAD_FAILED} />)
  }

  function onSuccessDownloadCsv(data: ExportCsvResponse) {
    if (data?.url) {
      createToastMessage(
        <ToastMessage
          messageType='success'
          title='Success'
          message='Your CSV Export has been successfully downloaded.'
        />,
      )

      const link = document.createElement('a')
      link.download = data?.fileName
      link.href = data.url
      link.target = '_blank'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  return { requestCsvExportUrl, isLoading }
}

/**
 * Formats current date/time for CSV export filenames
 * @returns Formatted date string in the format: YYYY-MM-DD-HH-MM-SS-AM/PM-TZ
 */
export function getFormattedDateTimeForExport(): string {
  return new Date()
    .toLocaleString('en-NZ', CSV_EXPORT_FILE_NAME_DATE_OPTIONS)
    .replace(/[/,: ]+/g, '-')
    .replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1')
}
